export const getSelectedCollection = state => {
  return state.home_ui.selected_collection;
};
